<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="warning" x-small depressed v-bind="attrs" v-on="on">
        소기업 규모 기준 >
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        주된 업종별 평균 매출액 등의 소기업 규모 기준
      </v-card-title>

      <v-card-text>
        <table>
          <tr>
            <th>번호</th>
            <th>업종</th>
            <th>분류기호</th>
            <th>기업 규모 기준</th>
          </tr>
          <tr>
            <td>1</td>
            <td>식료품 제조업</td>
            <td>C10</td>
            <td rowspan="17">평균매출액 등 120억원 이하</td>
          </tr>
          <tr>
            <td>2</td>
            <td>음료 제조업</td>
            <td>C11</td>
          </tr>
          <tr>
            <td>3</td>
            <td>의복, 의복액세서리 및 모피제품 제조업</td>
            <td>C14</td>
          </tr>
          <tr>
            <td>4</td>
            <td>가죽, 가방 및 신발 제조업</td>
            <td>C15</td>
          </tr>
          <tr>
            <td>5</td>
            <td>코크스, 연탄 및 석유정제품 제조업</td>
            <td>C19</td>
          </tr>
          <tr>
            <td>6</td>
            <td>화학물질 및 화학제품 제조업(의약품 제조업은 제외한다)</td>
            <td>C20</td>
          </tr>
          <tr>
            <td>7</td>
            <td>의료용 물질 및 의약품 제조업</td>
            <td>C21</td>
          </tr>
          <tr>
            <td>8</td>
            <td>비금속 광물제품 제조업</td>
            <td>C23</td>
          </tr>
          <tr>
            <td>9</td>
            <td>1차 금속 제조업</td>
            <td>C24</td>
          </tr>
          <tr>
            <td>10</td>
            <td>금속가공제품 제조업(기계 및 가구 제조업은 제외한다)</td>
            <td>C25</td>
          </tr>
          <tr>
            <td>11</td>
            <td>전자부품, 컴퓨터, 영상, 음향 및 통신장비 제조업</td>
            <td>C26</td>
          </tr>
          <tr>
            <td>12</td>
            <td>전기장비 제조업</td>
            <td>C28</td>
          </tr>
          <tr>
            <td>13</td>
            <td>그 밖의 기계 및 장비 제조업</td>
            <td>C29</td>
          </tr>
          <tr>
            <td>14</td>
            <td>자동차 및 트레일러 제조업</td>
            <td>C30</td>
          </tr>
          <tr>
            <td>15</td>
            <td>가구 제조업</td>
            <td>C32</td>
          </tr>
          <tr>
            <td>16</td>
            <td>전기, 가스, 증기 및 공기조절 공급업</td>
            <td>D</td>
          </tr>
          <tr>
            <td>17</td>
            <td>수도업</td>
            <td>E36</td>
          </tr>
          <tr>
            <td>18</td>
            <td>농업,임업 및 어업</td>
            <td>A</td>
            <td rowspan="14">평균매출액 등 80억원 이하</td>
          </tr>
          <tr>
            <td>19</td>
            <td>광업</td>
            <td>B</td>
          </tr>
          <tr>
            <td>20</td>
            <td>담배 제조업</td>
            <td>C12</td>
          </tr>
          <tr>
            <td>21</td>
            <td>섬유제품 제조업(의복 제조업은 제외한다)</td>
            <td>C13</td>
          </tr>
          <tr>
            <td>22</td>
            <td>목재 및 나무제품 제조업(가구 제조업은 제외한다)</td>
            <td>C16</td>
          </tr>
          <tr>
            <td>23</td>
            <td>펄프, 종이 및 종이제품 제조업</td>
            <td>C17</td>
          </tr>
          <tr>
            <td>24</td>
            <td>인쇄 및 기록매체 복제업</td>
            <td>C18</td>
          </tr>
          <tr>
            <td>25</td>
            <td>고무제품, 및 플라스틱제품 제조업</td>
            <td>C22</td>
          </tr>
          <tr>
            <td>26</td>
            <td>의료, 정밀, 광학기기 및 시계 제조업</td>
            <td>C27</td>
          </tr>
          <tr>
            <td>27</td>
            <td>그 밖의 운송장비 제조업</td>
            <td>C31</td>
          </tr>
          <tr>
            <td>28</td>
            <td>그 밖의 제품 제조업</td>
            <td>C33</td>
          </tr>
          <tr>
            <td>29</td>
            <td>건설업</td>
            <td>F</td>
          </tr>
          <tr>
            <td>30</td>
            <td>운수 및 창고업</td>
            <td>H</td>
          </tr>
          <tr>
            <td>31</td>
            <td>금융 및 보험업</td>
            <td>K</td>
          </tr>
          <tr>
            <td>32</td>
            <td>도매 및 소매업</td>
            <td>G</td>
            <td rowspan="2">평균매출액 등 50억원 이하</td>
          </tr>
          <tr>
            <td>33</td>
            <td>정보통신업</td>
            <td>J</td>
          </tr>
          <tr>
            <td>34</td>
            <td>수도, 하수 및 폐기물 처리, 원료재생업(수도업은 제외)</td>
            <td>E(E36 제외)</td>
            <td rowspan="5">평균매출액 등 30억원 이하</td>
          </tr>
          <tr>
            <td>35</td>
            <td>부동산업</td>
            <td>L</td>
          </tr>
          <tr>
            <td>36</td>
            <td>전문ᆞ과학 및 기술 서비스업</td>
            <td>M</td>
          </tr>
          <tr>
            <td>37</td>
            <td>사업시설관리, 사업지원 및 임대 서비스업</td>
            <td>N</td>
          </tr>
          <tr>
            <td>38</td>
            <td>예술, 스포츠 및 여가 관련 서비스업</td>
            <td>R</td>
          </tr>
          <tr>
            <td>39</td>
            <td>산업용 기계 및 장비 수리업</td>
            <td>C34</td>
            <td rowspan="6">평균매출액 등 10억원 이하</td>
          </tr>
          <tr>
            <td>40</td>
            <td>숙박 및 음식점업</td>
            <td>I</td>
          </tr>
          <tr>
            <td>41</td>
            <td>교육 서비스업</td>
            <td>P</td>
          </tr>
          <tr>
            <td>42</td>
            <td>보건업 및 사회복지 서비스업</td>
            <td>Q</td>
          </tr>
          <tr>
            <td>43</td>
            <td>
              수리(<span style="font-family: sans-serif">修理</span>) 및 기타
              개인 서비스업
            </td>
            <td>S</td>
          </tr>
        </table>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false"> 확인 </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
    }
  },
}
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}
</style>
